import { render, staticRenderFns } from "./LatestNewsCarousel.vue?vue&type=template&id=5f884b54&scoped=true"
import script from "./LatestNewsCarousel.vue?vue&type=script&lang=js"
export * from "./LatestNewsCarousel.vue?vue&type=script&lang=js"
import style0 from "./LatestNewsCarousel.vue?vue&type=style&index=0&id=5f884b54&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f884b54",
  null
  
)

export default component.exports